// extracted by mini-css-extract-plugin
export var filterIncDec = "_da-0";
export var leftBorder = "_da-1";
export var rightBorder = "_da-2";
export var stringInput = "_da-3";